exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inputBox{color:#aaa;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;padding-bottom:5px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/transfers/components/input-field.scss
// module id = 5164
// module chunks = 0